import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitContact = (payload) =>
  axios.post(`${API}/contact`, payload, { timeout: 25000 });
